const e = "_wrapper_eof2u_1", n = "_fullscreen_eof2u_16", o = "_logoWrapper_eof2u_23", r = "_logo_eof2u_23", t = "_innerWrapper_eof2u_32", u = "_menuItemsWrapper_eof2u_43", _ = "_menuButtonWrapper_eof2u_48", p = "_menuButton_eof2u_48", a = "_withoutIcon_eof2u_64", s = "_icon_eof2u_78", c = "_menuLink_eof2u_83", f = "_featureLinksWrapper_eof2u_86", i = "_triangle_eof2u_100", l = "_featureLink_eof2u_86", m = {
  wrapper: e,
  fullscreen: n,
  logoWrapper: o,
  logo: r,
  innerWrapper: t,
  menuItemsWrapper: u,
  menuButtonWrapper: _,
  menuButton: p,
  withoutIcon: a,
  icon: s,
  menuLink: c,
  featureLinksWrapper: f,
  triangle: i,
  featureLink: l
};
export {
  m as default,
  l as featureLink,
  f as featureLinksWrapper,
  n as fullscreen,
  s as icon,
  t as innerWrapper,
  r as logo,
  o as logoWrapper,
  p as menuButton,
  _ as menuButtonWrapper,
  u as menuItemsWrapper,
  c as menuLink,
  i as triangle,
  a as withoutIcon,
  e as wrapper
};
